import React, { useState } from 'react';
import { useNavigate, useSearchParams } from '../utils/SimpleRouter';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ResetPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    
    if (newPassword !== confirmPassword) {
      toast.error('Passordene stemmer ikke overens');
      return;
    }
    
    if (newPassword.length < 6) {
      toast.error('Passordet må være minst 6 tegn');
      return;
    }
    
    if (!token) {
      toast.error('Ugyldig eller manglende token');
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, null, {
        params: {
          token: token,
          new_password: newPassword
        }
      });
      
      toast.success('Passordet er tilbakestilt! Du kan nå logge inn.');
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (error) {
      console.error('Reset password error:', error);
      if (error.response?.status === 400) {
        toast.error('Ugyldig eller utløpt lenke. Be om en ny.');
      } else {
        toast.error('Kunne ikke tilbakestille passordet');
      }
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="reset-password-page">
        <div className="reset-container">
          <h2>❌ Ugyldig lenke</h2>
          <p>Denne lenken er ugyldig. Vennligst be om en ny lenke for passord-tilbakestilling.</p>
          <button onClick={() => navigate('/login')} className="btn btn-primary">
            Tilbake til innlogging
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="reset-password-page">
      <div className="reset-container">
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <img 
            src="/infovegg-logo.svg" 
            alt="Infovegg.no" 
            style={{ height: '60px', width: 'auto' }}
          />
        </div>
        <h2>🔑 Tilbakestill passord</h2>
        <p className="subtitle">Skriv inn ditt nye passord</p>
        
        <form onSubmit={handleResetPassword}>
          <div className="form-group">
            <label htmlFor="new-password">Nytt passord</label>
            <input
              type="password"
              id="new-password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              minLength={6}
              placeholder="Minst 6 tegn"
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirm-password">Bekreft passord</label>
            <input
              type="password"
              id="confirm-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              minLength={6}
              placeholder="Skriv inn passordet igjen"
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
          >
            {loading ? 'Lagrer...' : 'Lagre ditt nye passord'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
          <button
            onClick={() => navigate('/login')}
            style={{
              color: '#50E3C2',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              textDecoration: 'underline'
            }}
          >
            Tilbake til innlogging
          </button>
        </div>
      </div>
      
      <style>{`
        .reset-password-page {
          min-height: 100vh;
          background: linear-gradient(135deg, #50E3C2 0%, #429C88 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2rem;
        }
        
        .reset-container {
          background: white;
          padding: 3rem;
          border-radius: 16px;
          max-width: 450px;
          width: 100%;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
        }
        
        .reset-container h2 {
          color: #2A2A2A;
          margin-bottom: 0.5rem;
        }
        
        .subtitle {
          color: #666;
          margin-bottom: 2rem;
          text-align: center;
        }
        
        .form-group {
          margin-bottom: 1.5rem;
        }
        
        .form-group label {
          display: block;
          color: #2A2A2A;
          margin-bottom: 0.5rem;
          font-weight: 600;
        }
        
        .form-group input {
          width: 100%;
          padding: 0.75rem 1rem;
          border: 2px solid #e0e0e0;
          border-radius: 8px;
          font-size: 1rem;
          color: #2A2A2A;
          background: white;
        }
        
        .form-group input:focus {
          outline: none;
          border-color: #50E3C2;
        }
        
        .btn {
          width: 100%;
          padding: 1rem;
          font-size: 1.1rem;
          margin-top: 1rem;
        }
      `}</style>
    </div>
  );
};

export default ResetPassword;
